import React from 'react'
import { Container, Row, Col, Image } from 'react-bootstrap'
import macMockup from '../../../Assets/images/cultured-img/landing-page-img/mac-mockup.png'
import DaimondGif from '../../../Assets/images/cultured-img/landing-page-img/diamond-iframe.gif'
import { NavLink } from 'react-router-dom'

const LooseDiamondPage = () => {
    return (
        <>
            <div className='dfld_loose_diamond_Section'>
                <Container className='dfl_custome_container_staticpage'>
                    <Row className='w-100 m-auto'>
                        <Col sm={12} md={5} lg={6} className="dfld_looss_img">
                            <div className='dhld_gif_box position-relative'>
                                <Image src={macMockup} alt="Mockup Image" className='img-fluid' />
                                <div className='dfl_diamond_gif'>
                                    <Image src={DaimondGif} alt=" Diamond GIF" className='dfl_diamond_gif' />
                                </div>
                            </div>
                        </Col>
                        <Col sm={12} md={7} lg={6}>
                            <div className='dfld_loose_text_box'>
                                <div className="eng-box3 text-center ">
                                    <div>
                                        <h2>Examine Each Diamond In </h2>
                                        <h1> 360-Degree HD View  </h1>
                                        <h3 className="title24 text-uppercase m10">Pick Your Diamonds Wisely! </h3>
                                    </div>
                                    <p>
                                    Even though certification is vital when buying a diamond, observing it under close proximity will allow you to make a wiser decision when choosing one. 
                                    </p>
                                    <p>Curate a beautiful engagement ring with the finest loose diamonds. </p>
                                    <div className="eng-btn ">
                                        <div className="btn-wrapper row text-center pt-0">
                                            <div className="col-md-6 col-sm-6 col-lg-6 col-xs-12">
                                                <NavLink
                                                    className="btn-engage"
                                                    to="/ringsettings"
                                                >
                                                    ENGAGEMENT RINGS 
                                                </NavLink>
                                            </div>
                                            <div className="col-md-6 col-sm-6 col-lg-6 col-xs-12">
                                                <NavLink
                                                    className="btn-engage"
                                                    to="/diamonds/lab"
                                                >
                                                    Lab Created
                                                </NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default LooseDiamondPage